import { Component, Input } from '@angular/core';
import { AvailableTransport } from '../../model/sac-client.model';
import { DashboardContext } from '@sdbn/appclient';
import { TransportTaskStatus } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-transport-list-entry',
  templateUrl: './transport-list-entry.component.html',
  styleUrls: ['./transport-list-entry.component.scss']
})
export class TransportListEntryComponent {

  @Input()
  transport: AvailableTransport;

  TransportTaskStatus = TransportTaskStatus;

  @Input()
  selected: boolean;

  @Input() dashboardContext: DashboardContext;
}
